import { FC } from "react"
import classNames from "classnames"
import CellCardContent from "./CellCardContent"
import { useCellCardState } from "./useCellCardState"
import { CellCardProps } from "."
import { TestId } from "@/constants/globals"
import "./index.scss"

const CellCardLarge: FC<CellCardProps> = ({
   cellId,
   bpm,
   bpmStabilityScore,
   rpm,
   rpmStabilityScore,
   occupied,
   maintenance,
   isCustom = false,
   hasDoorSensor,
   doorSensorLowBattery,
   cellStatus: cell,
   userStatus,
   typefaceColor,
   hideButtons,
   isExpanded,
   onClick,
   onSetVacant = () => {},
   onSetMaintenanceOff = () => {},
   onViewDetails = () => {},
   onTriggerTestAlarm,
}) => {
   const { cellStatus, typefaceClassName, noVitals } = useCellCardState({
      cellStatus: cell,
      occupied,
      maintenance,
      typefaceColor,
      userStatus,
   })

   return (
      <div
         data-testid={TestId.CELL_CARD}
         className={classNames(
            "cell-card",
            "cell-card--large",
            `cell-card--${cellStatus}`,
            typefaceClassName,
            {
               "cell-card--with-status-icon": noVitals,
               "cell-card--clickable": onClick && isExpanded,
               "cell-card--expanded": isExpanded,
               "cell-card--custom": isCustom,
            }
         )}
         onClick={onClick}
      >
         <CellCardContent
            cellId={cellId}
            isCustom={isCustom}
            hasDoorSensor={hasDoorSensor}
            doorSensorLowBattery={doorSensorLowBattery}
            userStatus={userStatus}
            maintenance={maintenance}
            hideButtons={hideButtons}
            onSetVacant={onSetVacant}
            onSetMaintenanceOff={onSetMaintenanceOff}
            cellStatus={cell}
            typefaceColor={typefaceColor}
            occupied={occupied}
            bpm={bpm}
            bpmStabilityScore={bpmStabilityScore}
            rpm={rpm}
            rpmStabilityScore={rpmStabilityScore}
            onViewDetails={onViewDetails}
            onTriggerTestAlarm={onTriggerTestAlarm}
         />
      </div>
   )
}

export default CellCardLarge
